import { createElement, memo, useEffect, useState, useRef, useCallback, useMemo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import ScrollView from '@hfe/max-scrollview';
// import LText from '@max/leez-text';
import Card from './components/Card';
import Icon from '@max/leez-icon';
import './index.scss';
import Image from '@hfe/max-image';
import { getPlatformType, getSystemType, PlatformType } from '@nibfe/mkt-env-api';
const systemType = getSystemType();
import fetchData, { ExperimentPageFlag } from './api';
import { LOAD_MORE_TYPE } from './types';
import { DYNAMIC_LIST_SCENE_TOKEN, LX_CONFIG, SHOW_TYPE_ENUM, LABEL_FILTER_INFORS } from './constants';
import Sensor from '@max/mbc-sensor';
import { navigateBack } from '@max/meituan-uni-navigate';
import Skeleton from './Skeleton';
import { evokeMtAappUrl } from './common-api/utils';
import LoadingView from '@max/leez-loading-view';
import { useUserInfo } from './common-api/use-user';
import { useLocation } from './hooks/useLocation';
import { login, getUserInfo } from '@nibfe/mkt-user-api';
import { getLBSInfo } from '@nibfe/mkt-lbs-api';
import { debounce, getUTM } from './utils';
import { useMonitorEngineContext, useMonitorNavigation } from '@nibfe/mcp-monitor-sdk';
import ComparePriceCard from './components/ComparePriceCard';
var STYLE_TYPE;
(function (STYLE_TYPE) {
    STYLE_TYPE["COMMON"] = "common";
    STYLE_TYPE["CARD"] = "card";
})(STYLE_TYPE || (STYLE_TYPE = {}));
const DEFAULT_CITY_ID = 1;
const HotelDynamicPoiList = (props) => {
    const { userInfo } = useUserInfo();
    const { location, locationDone } = useLocation(DYNAMIC_LIST_SCENE_TOKEN);
    const { 
    // poiDataInfo,
    supplyTagId, landingSceneGroupId, styleType, sortType, pageSize, showType, singleRowShowMoreJumpLink, loadMoreType, fullRoomBase, marginTop, marginBottom, noDataText, noDataTextColor, noDataBackgroundColor, noDataImg, noDataJumpLink, clickBizLine, loadMoreForceLogin, isShowLabelFilter, isRelatedCityFilter, isOpenComparePriceTag, poiIdListString, poiIdUrlExtraParamsString, isOpenExperiment } = props;
    const userId = useRef('');
    const userUuid = useRef('');
    const offset = useRef(0);
    const searchText = useRef('');
    const landmark = useRef('');
    const checkInTimestamp = useRef(null);
    const checkOutTimestamp = useRef(null);
    const [labelFilterList, setLabelFilterList] = useState([]);
    const labelFilterListRef = useRef([]);
    const locationRef = useRef(location);
    const labelFilterInfos = useRef(LABEL_FILTER_INFORS);
    // const {request, response, requestStatus} = useRequest<Data, BackendProductShelfVo>()
    // const { uuid, poiTagId } = poiDataInfo ?? {};
    const ctx = useMonitorEngineContext();
    const { monitorNavigateTo } = useMonitorNavigation();
    // 优先走跳链上拼接的cityId
    const cityId = useRef(ctx?._runtimeInfo?.queryParams?.cityId ?? DEFAULT_CITY_ID);
    const { _LXReport, _moduleId } = ctx;
    const [poiList, setPoiList] = useState([]);
    const [noMore, setNoMore] = useState(false);
    const [showSkeleton, setShowSkeleton] = useState(false);
    const [showNoDataView, setShowNoDataView] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const isCityInitializedDefault = !isRelatedCityFilter;
    const isCityInitialized = useRef(isCityInitializedDefault);
    const queryId = useRef('');
    const isFirstRequrestDone = useRef(false);
    const commonParams = ctx?._runtimeInfo?.commonParams || {};
    const cityInfo = commonParams.cityInfo || {};
    const localCityId = cityInfo.locCityId;
    const getFrontListVo = (backendProductList) => {
        const { buyButtonText, headIcon, headIconImg, headIconText, headIconTextColor, headIconBackgroundColor, scoreInfoSwitch, distanceInfoSwitch, salesInfoSwitch, bookInfoSwitch, priceColor, buyButtonTextColor, buyButtonBackgroundColor } = props;
        const result = [];
        if (!(backendProductList && backendProductList?.length)) {
            return [];
        }
        backendProductList.forEach(backendProduct => {
            const { headImage, title, positionInfo, priceModel, status, rating, userReview, score, salesCount, extModel, bookInfo, positionMsg, productId, angleImg, privilegeTag } = backendProduct;
            const poiListCard = {
                headImage: {
                    value: headImage
                },
                title,
                positionInfo: positionInfo?.[0] ?? '',
                price: priceModel,
                status,
                buyButtonText,
                salesCount,
                score,
                rating,
                userReview: userReview[0] ? `${userReview[0]}` : '',
                headIcon,
                headIconImg,
                headIconText,
                headIconTextColor,
                headIconBackgroundColor,
                extModel,
                bookInfo,
                scoreInfoSwitch,
                distanceInfoSwitch,
                salesInfoSwitch,
                bookInfoSwitch,
                priceColor,
                buyButtonTextColor,
                buyButtonBackgroundColor,
                lat: positionMsg.lat,
                lng: positionMsg.lng,
                poiId: productId,
                angleImg,
                privilegeTag
            };
            result.push(poiListCard);
        });
        return result;
    };
    useEffect(() => {
        locationRef.current = location;
    }, [location]);
    const getPoiList = async (refresh = false) => {
        console.log('isRelatedCityFilter', isRelatedCityFilter, isCityInitialized.current);
        if (isRelatedCityFilter && !isCityInitialized.current && !props.supplyTagId)
            return;
        const platform = getPlatformType();
        const isDianping = [PlatformType.dpApp, PlatformType.dpAppWebView, PlatformType.dpMinaWebview].includes(platform);
        const reqData = {
            dynamicTagId: supplyTagId,
            // TODO 可删除的
            cityId: cityId.current,
            fullPoiFormat: fullRoomBase,
            offset: offset.current,
            limit: pageSize,
            sort: sortType,
            sortWithPrivilegePoi: props?.sortWithPrivilegePoi,
            hotelChannel: ctx?._runtimeInfo?.queryParams?.hotelchannel,
            landingSceneGroupId: landingSceneGroupId || undefined,
            queryId: queryId.current || ''
        };
        if (isOpenExperiment) {
            reqData.experimentPageFlag = ExperimentPageFlag.OPEN;
        }
        if (searchText.current) {
            reqData.query = searchText.current;
        }
        if (landmark.current) {
            reqData.hotSpot = landmark.current;
        }
        if (checkInTimestamp.current && checkOutTimestamp.current) {
            reqData.checkInTimestamp = checkInTimestamp.current;
            reqData.checkOutTimestamp = checkOutTimestamp.current;
        }
        if (Array.isArray(labelFilterListRef.current) && labelFilterListRef.current.length) {
            reqData.labelFilterList = labelFilterListRef.current;
        }
        // 预览态，需要注意
        // @ts-ignore
        if (window?.inEditor) {
            reqData.previewId = '1';
        }
        try {
            if (!refresh) {
                setShowLoading(true);
            }
            setShowNoDataView(false);
            const params = {
                userId: userId.current,
                userid: userId.current,
                utm_medium: getUTM(),
                uuid: userUuid.current,
                gps_cityid: localCityId,
                // utm_source: ,
                // utm_term: ,
                unionId: userInfo.unionId,
                utm_content: userUuid.current,
                utm_campaign: isDianping ? 'Adianping-novaBdianping-novaD0H0' : 'Meituan' // 决定筛选POI的城市体系
            };
            if (locationRef.current) {
                const { lat, lng } = locationRef.current;
                // @ts-expect-error ADD
                params.mypos = `${lat},${lng}`; // 后端历史逻辑使用 {维度,经度}
            }
            console.log('params before fetchData: ', params);
            console.log('reqData before fetchData: ', reqData);
            // 发请求
            ctx._raptorReport.reportMetric({
                'mcptex.network.sent': [1]
            }, {
                tags: {
                    component: 'dynamic-poi-list'
                }
            });
            // const data = await request({
            //   requestConfig: {
            //     path: API_PATH.STATIC_SUPPLY_DELIVERY,
            //     method: 'POST',
            //     params: params
            //   }
            // })
            // console.log(response)
            const { total, productModelList, queryId: cacheQueryId } = (await fetchData(reqData, params, {
                onApiSuccess: () => {
                    // 网络请求成功了🎉
                    ctx._raptorReport?.monitorReportNetworkSuccess?.();
                },
                onApiFail: () => {
                    // 网络请求失败了
                    ctx._raptorReport?.monitorReportNetworkFailed?.();
                }
            }));
            queryId.current = cacheQueryId;
            if (Array.isArray(productModelList)) {
                // 返回数据合理，上报业务成功
                ctx._raptorReport?.monitorReportBizSuccess?.();
                if (total === 0 || productModelList.length === 0) {
                    // 货架空搜
                    ctx._raptorReport?.monitorReportShelfEmpty?.({
                        city_id: cityId.current
                    });
                }
                else {
                    // 货架没有空搜
                    ctx._raptorReport?.monitorReportShelfNormal?.();
                }
            }
            else {
                // 返回数据不合理，上报业务失败
                ctx._raptorReport?.monitorReportBizFailed?.({
                    city_id: cityId.current
                });
            }
            isFirstRequrestDone.current = true;
            if (cityId.current !== reqData.cityId)
                return;
            const frontList = getFrontListVo(productModelList);
            let newPoiList = [];
            if (refresh) {
                newPoiList = [...frontList];
            }
            else {
                newPoiList = poiList.concat(...frontList);
            }
            if (newPoiList?.length && newPoiList.length >= total) {
                setNoMore(true);
            }
            else {
                setNoMore(false);
            }
            // 初始化就无货时，认为该城市无货，走兜底逻辑
            if (refresh && newPoiList?.length === 0) {
                setShowNoDataView(true);
                setNoMore(true);
            }
            setPoiList(newPoiList);
            offset.current = offset.current + pageSize;
        }
        catch (error) {
            ctx._uiInteractionAPI.toast.show({
                content: '活动太火爆啦～'
            });
        }
        setShowSkeleton(false);
        setShowLoading(false);
        isFirstRequrestDone.current = true;
    };
    const init = () => {
        offset.current = 0;
        queryId.current = '';
        setShowSkeleton(true);
        setPoiList([]);
        getPoiList(true);
    };
    // 将init封装成防抖函数
    const debouncedInit = debounce(init, 100);
    const loadMore = async () => {
        if ((!userId.current || !userUuid.current) && loadMoreForceLogin) {
            // console.log("分支1");
            // console.log('userUuid.current: ', userUuid.current);
            // console.log('userId.current: ', userId.current);
            const res = await login();
            // console.log('res: ', res);
            if (res?.userId) {
                const userInfoAfterLogin = await getUserInfo();
                // console.log('userInfoAfterLogin: ', userInfoAfterLogin);
                const { userId: originalUserId, uuid: user_uuid } = userInfoAfterLogin ?? {};
                if (originalUserId) {
                    userId.current = originalUserId;
                    userUuid.current = user_uuid;
                    init();
                }
            }
            else {
                setTimeout(() => {
                    navigateBack({
                        _web: {
                            miniProgramNative: true //说明：此参数只在web端生效。1）如果在小程序/点评&美团APP中，为ture的话会调用native的方法，也就是直接关闭这个页面，为fase或不传在当前webview中返回。
                        }
                    });
                }, 500);
            }
        }
        else {
            console.log("分支2");
            getPoiList();
        }
    };
    useEffect(() => {
        (async () => {
            if (userInfo.done && locationDone) {
                const { userId: originalUserId, uuid: user_uuid } = userInfo ?? {};
                if (originalUserId) {
                    userId.current = originalUserId;
                    userUuid.current = user_uuid;
                }
                if (props.isHomeSelectedCityIdDefault) {
                    try {
                        let locationInfo = await getLBSInfo({
                            needLocation: true,
                            sceneToken: 'dd-9cbc1c31cfbf2bba'
                        });
                        if (locationInfo) {
                            cityId.current = locationInfo.homeSelectedCity || 1;
                        }
                    }
                    catch (error) {
                        console.log('poi动态列表获取定位信息失败');
                    }
                }
                if (props.isAllCityShow) {
                    cityId.current = 0;
                }
                await init();
            }
        })();
    }, [userInfo.done, locationDone]);
    useEffect(() => {
        // @ts-ignore
        if (window?.inEditor) {
            // 在画布中确保后端已更新数据
            setTimeout(() => {
                init();
            }, 2000);
        }
    }, [supplyTagId]);
    const onCityChange = useCallback((city) => {
        if (city?.value) {
            cityId.current = Number(city.value);
            console.log('poi动态列表，监听到城市变化', city.value);
            isCityInitialized.current = true;
            if (userInfo.done) {
                setTimeout(() => {
                    debouncedInit();
                }, 0);
            }
        }
    }, [userInfo.done]);
    const onSearchParamChange = useCallback((params) => {
        const isCityIdChanged = cityId.current !== params.cityId;
        if (params.cityId) {
            isCityInitialized.current = true;
        }
        const isSearchTextChanged = searchText.current !== (params.searchText || '');
        if (isCityIdChanged || isSearchTextChanged) {
            setLabelFilterList([]); // 重置标签筛选
        }
        cityId.current = params.cityId;
        landmark.current = params.landmark || '';
        searchText.current = params.searchText || '';
        checkInTimestamp.current = params.checkInTimestamp || null;
        checkOutTimestamp.current = params.checkOutTimestamp || null;
        if (userInfo.done) {
            debouncedInit();
        }
    }, [userInfo.done]);
    useEffect(() => {
        labelFilterListRef.current = labelFilterList;
        if (isFirstRequrestDone.current) {
            // NOTE: 临时屏蔽第一次请求
            debouncedInit();
        }
    }, [labelFilterList]);
    useEffect(() => {
        ctx?._communication?.on('cityChanged', onCityChange);
        return () => {
            ctx?._communication?.off('cityChanged', onCityChange);
        };
    }, [onCityChange]);
    useEffect(() => {
        ctx?._communication?.on('dynamicPoiListSearchParamsChanged', onSearchParamChange);
        return () => {
            ctx?._communication?.off('dynamicPoiListSearchParamsChanged', onSearchParamChange);
        };
    }, [onSearchParamChange]);
    const onComponentShowMV = () => {
        _LXReport?.mvReport(LX_CONFIG.COMP_MV_BID, {
            valLab: {
                _moduleId: _moduleId ?? '-999',
                tex_id: ctx?._runtimeInfo?.queryParams?.pageId ?? '-999',
                custom: {
                    click_biz_line: clickBizLine ?? '-999',
                    hotel_channel: ctx?._runtimeInfo?.queryParams?.hotelchannel ?? '-999'
                }
            }
        });
    };
    const poiIdList = useMemo(() => {
        let result = [];
        try {
            if (poiIdListString) {
                result = poiIdListString?.trim()?.split(',');
            }
        }
        catch (error) {
            ctx?._raptorReport?.reportLog('解析PoiList错误', new Error('解析PoiList错误'), {
                tags: {
                    poiIdListString
                }
            });
        }
        return result;
    }, [poiIdListString]);
    const handleClickLabelFilter = useCallback(labelInfo => {
        const { value } = labelInfo;
        setLabelFilterList(prev => {
            const isSelected = prev.includes(value);
            return isSelected ? prev.filter(item => item !== value) : [...prev, value];
        });
    }, []);
    const renderLabelFilter = useCallback(() => {
        if (!isShowLabelFilter) {
            return null;
        }
        return <ScrollView className="hotel-dynamic-poi-tag-cntr" horizontal={true} showsHorizontalScrollIndicator={false}>
        {labelFilterInfos.current.map(labelInfo => {
            const { label, value } = labelInfo;
            const isSelected = labelFilterList?.includes(value);
            return <View className={isSelected ? ["hotel-dynamic-poi-tag-item", "hotel-dynamic-poi-tag-item-selected"] : "hotel-dynamic-poi-tag-item"} key={value} onClick={() => handleClickLabelFilter(labelInfo)}>
              <Text className={isSelected ? ["hotel-dynamic-poi-tag-text", "hotel-dynamic-poi-tag-text-selected"] : "hotel-dynamic-poi-tag-text"} numberOfLines={1}>{label}</Text>
            </View>;
        })}
      </ScrollView>;
    }, [isShowLabelFilter, labelFilterList]);
    const jumpToNoDataFallbackPage = () => {
        if (window?.inEditor) {
            return;
        }
        if (!noDataJumpLink) {
            return;
        }
        monitorNavigateTo({
            url: evokeMtAappUrl(noDataJumpLink),
            _web: {
                miniProgramNative: true
            },
            _meituan: {
                enableElinkLog: true // 开启 Elink 日志上报
            }
        }).then((value) => {
            console.log('open success', value);
        }).catch((err) => {
            console.log('open error', err);
        });
    };
    if (showSkeleton) {
        return <View className="hotel-dynamic-poi-list-container" style={{
            marginTop,
            marginBottom,
            paddingLeft: showType === SHOW_TYPE_ENUM.SIGNAL_ROW ? '12rpx' : '24rpx',
            paddingRight: showType === SHOW_TYPE_ENUM.SIGNAL_ROW ? '12rpx' : '24rpx'
        }}>
        {renderLabelFilter()}
        <Skeleton showType={showType}/>
      </View>;
    }
    if (showNoDataView) {
        return <View className="hotel-dynamic-poi-list-container" style={{
            marginTop,
            marginBottom,
            paddingLeft: showType === SHOW_TYPE_ENUM.SIGNAL_ROW ? '12rpx' : '24rpx',
            paddingRight: showType === SHOW_TYPE_ENUM.SIGNAL_ROW ? '12rpx' : '24rpx'
        }}>
        {renderLabelFilter()}
        <View style={{
            backgroundColor: noDataBackgroundColor
        }} className="hotel-dynamic-poi-list-no-data-container" onClick={() => {
            jumpToNoDataFallbackPage();
        }}>
          <Text style={{
            color: noDataTextColor
        }} className="hotel-dynamic-poi-list-no-data-text">
            {noDataText}
          </Text>
          <Image style={{
            width: '750rpx'
        }} source={{
            uri: noDataImg
        }}/>
        </View>
      </View>;
    }
    return <Sensor once onAppear={() => {
        onComponentShowMV();
    }}>
      <View className="hotel-dynamic-poi-list-container" style={{
        marginTop,
        marginBottom,
        paddingLeft: showType === SHOW_TYPE_ENUM.SIGNAL_ROW ? '12rpx' : '24rpx',
        paddingRight: showType === SHOW_TYPE_ENUM.SIGNAL_ROW ? '12rpx' : '24rpx'
    }}>
        {renderLabelFilter()}
        <View x-if={showType === SHOW_TYPE_ENUM.TWO_LIST}>
          <View className="hotel-dynamic-poi-list-card-wrap">
            {(poiList ?? []).map((poi, index) => styleType === STYLE_TYPE.COMMON ? <ComparePriceCard poiInfo={{
        ...poi
    }} style={{
        marginTop: index < 2 ? 0 : '18rpx'
    }} key={poi.extModel?.poiId ?? poi.extModel?.poiIdStr ?? index} clickBizLine={clickBizLine} isOpenComparePriceTag={isOpenComparePriceTag} poiIdList={poiIdList} poiIdUrlExtraParamsString={poiIdUrlExtraParamsString}/> : <Card poiInfo={{
        ...poi
    }} style={{
        marginTop: index < 2 ? 0 : '18rpx'
    }} key={poi.extModel?.poiId ?? poi.extModel?.poiIdStr ?? index} clickBizLine={clickBizLine} poiIdList={poiIdList} poiIdUrlExtraParamsString={poiIdUrlExtraParamsString}/>)}
          </View>
          <LoadingView x-if={showLoading} level={'medium'} showContent={false} style={{
        marginTop: '20rpx'
    }}/>
          <View x-if={!noMore && loadMoreType === LOAD_MORE_TYPE.BUTTON && poiList?.length > 0} className="hotel-dynamic-poi-list-show-more-container" onClick={() => loadMore()}>
            <View className="hotel-dynamic-poi-list-show-more-button">
              <Text className="hotel-dynamic-poi-list-show-more-text">查看更多</Text>
              <Icon name="jiantouxianxia" color="#555555"/>
            </View>
          </View>
          <Sensor x-if={!noMore && loadMoreType === LOAD_MORE_TYPE.PULL_UP && poiList?.length > 0} className="hotel-dynamic-poi-list-load-more-sensor" onAppear={() => {
        loadMore();
    }}/>
        </View>
        <View x-elseif={showType === SHOW_TYPE_ENUM.SIGNAL_ROW}>
          <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} onEndReached={() => {
        if (!noMore && loadMoreType === LOAD_MORE_TYPE.PULL_UP && poiList?.length > 0) {
            loadMore();
        }
    }}>
            {loadMoreType === LOAD_MORE_TYPE.BUTTON && (poiList ?? []).slice(0, 10).map((poi, index) => <Card poiInfo={{
        ...poi
    }} style={{
        marginRight: '18rpx'
    }} showType={SHOW_TYPE_ENUM.SIGNAL_ROW} key={poi.extModel?.poiId ?? poi.extModel?.poiIdStr ?? index} clickBizLine={clickBizLine} poiIdList={poiIdList} poiIdUrlExtraParamsString={poiIdUrlExtraParamsString}/>)}
            {loadMoreType === LOAD_MORE_TYPE.PULL_UP && poiList.map((poi, index) => <Card poiInfo={{
        ...poi
    }} style={{
        marginRight: '18rpx'
    }} showType={SHOW_TYPE_ENUM.SIGNAL_ROW} key={poi.extModel?.poiId ?? poi.extModel?.poiIdStr ?? index} clickBizLine={clickBizLine} poiIdList={poiIdList} poiIdUrlExtraParamsString={poiIdUrlExtraParamsString}/>)}
            <LoadingView x-if={loadMoreType === LOAD_MORE_TYPE.PULL_UP && showLoading} level={'medium'} showContent={false} style={{
        marginLeft: '20rpx'
    }}/>
            <View x-if={loadMoreType === LOAD_MORE_TYPE.BUTTON || noMore} className="hotel-dynamic-poi-list-row-type-show-more-button" onClick={() => {
        monitorNavigateTo({
            url: evokeMtAappUrl(singleRowShowMoreJumpLink?.indexOf('?') > -1 ? `${singleRowShowMoreJumpLink}&cityId=${cityId.current}` : `${singleRowShowMoreJumpLink}?cityId=${cityId.current}`)
        });
    }}>
              <View className="hotel-dynamic-poi-list-row-type-show-more-view">
                {'点击查看更多'.split('').map((char, index) => <Text key={char} className="hotel-dynamic-poi-list-row-type-show-more-text" style={{
        color: 'white',
        height: '32rpx',
        fontFamily: 'PingFang SC',
        fontWeight: '400',
        fontSize: '24rpx',
        letterSpacing: 0
    }}>
                    {char}
                  </Text>)}
              </View>
            </View>
          </ScrollView>
        </View>
      </View>
    </Sensor>;
};
export async function _customPVReportParams(params) {
    const custom = {
        hotel_channel: params?.queryParams?.['hotelchannel'] || '-999',
        tex_id: params?.queryParams?.['pageId'] || '-999'
    };
    if (window?.location?.href) {
        custom.url = window.location.href;
    }
    return {
        custom: custom
    };
}
export default memo(HotelDynamicPoiList);
